import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeLatLongDto implements IEmployeeLatLongDto {
    latitude!: number;
    longitude!: number;
    employee!: EmployeeSummaryDto;
    allowLongLatDist!: number;
    thumbIn!: Date | undefined;
    thumbOut!: Date | undefined;
    fullDayMinutes!: number;
    companyName!: string | undefined;

    constructor(data?: IEmployeeLatLongDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.allowLongLatDist = _data["allowLongLatDist"];
            this.thumbIn = _data["thumbIn"] ? new Date(_data["thumbIn"].toString()) : <any>undefined;
            this.thumbOut = _data["thumbOut"] ? new Date(_data["thumbOut"].toString()) : <any>undefined;
            this.fullDayMinutes = _data["fullDayMinutes"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): EmployeeLatLongDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeLatLongDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["allowLongLatDist"] = this.allowLongLatDist;
        data["thumbIn"] = this.thumbIn ? this.thumbIn.toISOString() : <any>undefined;
        data["thumbOut"] = this.thumbOut ? this.thumbOut.toISOString() : <any>undefined;
        data["fullDayMinutes"] = this.fullDayMinutes;
        data["companyName"] = this.companyName;
        return data; 
    }
}

export interface IEmployeeLatLongDto {
    latitude: number;
    longitude: number;
    employee: EmployeeSummaryDto;
    allowLongLatDist: number;
    thumbIn: Date | undefined;
    thumbOut: Date | undefined;
    fullDayMinutes: number;
    companyName: string | undefined;
}

